export default __webpack_public_path__ + "static/media/le_croisemini.44b2d072.jpg";